import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';
import { reloadPageBypassingCache } from '../../../util/reloadPage';

const maintenanceImagePath = `${
  process.env.PUBLIC_URL || ''
}/img/maintenance.png`;

const UpdateRequired = ({ intl }) => {
  return (
    <div className="FatalError">
      <img src={maintenanceImagePath} alt="Update required" />
      <p>
        <input
          type="button"
          className="FatalError__reload"
          value={intl.formatMessage(globalTranslations.errorRefresh)}
          onClick={reloadPageBypassingCache}
        />
      </p>
      <h3>
        <FormattedMessage
          id="bootstrap.updateRequiredHeader"
          defaultMessage="A new version of the store is available"
        />
      </h3>
      <p>
        <FormattedMessage
          id="bootstrap.updateRequiredMessage"
          defaultMessage="Your browser is using an older version of the storefront. Reload the page to fetch the latest version."
        />
      </p>
    </div>
  );
};

UpdateRequired.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(UpdateRequired);
